import crypto from "../util/crypto";
import Public from "../util/public";
import Http from "../util/http";
import Vue from "vue";

export default {
    paymentRequest: {
        storeToken: "",
        objectTypeToken: "",
        objectIdToken: "",
        orderTmpId: 0,
        paymentType: "",
        method: "",
        apiToPay: "",
        apiToFunc: "",
        isApp: "",
        funcId: 0,
        userId: 0,
    },

    //選擇金流呼叫後端閘道
    getPayment: async (payData) => {
        // console.log(payData);
        switch (payData.paymentType) {
            case "newebpayMPG":
            case "bindNewebpayMPG": {
                let payToken = crypto.objectToURIComponent(payData);
                let result = await creditCardOpenWindow(
                    payToken,
                    payData.orderTmpId,
                    payData.isApp,
                    payData.paymentType,
                    payData.userId,
                );
                return result;
            }
            default: {
                break;
            }
        }
    },

    async bindCreditCard(successFunc, failFunc) {
        let self = this
        let userId
        try {
            let decrypted = crypto.decryptText(localStorage.getItem('admin_token'));
            userId = Number(decrypted.split(';')[0]);
        } catch (e) {
            userId = 0
        }

        if (userId > 0) {
            //金流專案需要的相關資料
            self.paymentRequest = {
                paymentType: "bindNewebpayMPG",
                userId: userId,
                orderTmpId: 0,
            }
            self.payResult = await self.getPayment(self.paymentRequest)
            //付款完成彈出視窗內容
            if (self.payResult.status) {
                successFunc(self.payResult)
            } else {
                failFunc(self.payResult)
            }
        } else {
            Public.showNotify("請先登入", false);
        }
    },
    creditCardOpenVerifyWeb: async (orderTmpId, htmlContent) => {
        return new Promise((resolve, reject) => {
            let browser = Public.getBrowser();
            if (Public.isCordova()) {
                let encodedHtml = `data:text/html;base64,${btoa(htmlContent)}`
                let appInBrowser = browser.open(
                    encodedHtml,
                    "_blank",
                    "location=no,toolbar=yes,toolbarposition=top,closebuttoncaption=關閉,closebuttoncolor=#f8de6f,toolbarcolor=#343a40,navigationbuttoncolor=#f8de6f" + Http.browserOpenFeatures({isFooter: true})
                );
                appInBrowser.addEventListener("exit", async function (event) {
                    resolve(await creditCardCloseWindow(orderTmpId, "", 0))
                });
            } else {
                browser.open(htmlContent, "_blank");
            }
        })
    },
};

const creditCardOpenWindow = (payToken, orderTmpId, isApp, paymentType, userId) => {
    return new Promise((resolve, reject) => {
        /*開啓藍薪信用卡畫面 */
        let getResult = "";
        // console.log("打開藍新網頁");
        let urlSet =
            process.env.VUE_APP_PAYMENT_API_HOST +
            "/neweb/newebpayPost" +
            "?token=" +
            payToken;
        var browser = Public.getBrowser();
        //使用 _system的話會呼叫 app外部的 browser來開網頁

        if (Public.isCordova()) {
            // console.log("this is app");
            let appInBrowser = browser.open(
                urlSet,
                "_blank",
                "location=no,toolbar=yes,toolbarposition=top,closebuttoncaption=關閉,closebuttoncolor=#f8de6f,toolbarcolor=#343a40,navigationbuttoncolor=#f8de6f" + Http.browserOpenFeatures({isFooter:true})
            );
            appInBrowser.addEventListener("exit", async function(event) {
                // 監聽 '視窗關閉' 事件
                getResult = await creditCardCloseWindow(orderTmpId, paymentType, userId);
                resolve(getResult);
            });
        } else {
            // console.log("this isn't app");
            //網頁使用藍新頁面返回商店方法
            browser.open(urlSet, "_self");
            // var loop = setInterval(async function() {
            //     if (newBrowser.closed) {
            //         // console.log("藍新網頁被關閉了");
            //         clearInterval(loop);
            //         getResult = await creditCardCloseWindow(orderTmpId);
            //         if (getResult !== "") {
            //             resolve(getResult);
            //         }
            //     }
            // }, 1000);
        }
    });
};
const creditCardCloseWindow = (orderTmpId, paymentType, userId) => {
    return new Promise((resolve, reject) => {
        /* 關閉藍薪信用卡畫面轉跳成功頁面 */
        Vue.prototype.$http.fetchWithEncrypt`PaymentCompleted${{
            orderTmpId: orderTmpId,
            paymentType: paymentType,
            userId: userId,
        }}
        ${(json) => {
            resolve(json);
        }}`;
    });
};
